import { LegacyRef, memo, MouseEventHandler, useCallback } from 'react'
import { LinkProps, useNavigate } from '@tanstack/react-router'
import cn from 'classnames'
import { IButtonProps } from 'components/ui/Button'

import { BaseLink } from './BaseLink'
import { IGeneralProps } from './types'

import s from './LinkButton.module.less'

type IProps = {
  contentPosition?: 'contentStart' | 'contentCenter' | 'contentEnd' | 'contentSpaceBetween'
  hasPadding?: boolean
  innerRef?: LegacyRef<HTMLAnchorElement>
  size?: IButtonProps['size']
  testId?: string
  to?: LinkProps['to']
} & Omit<IGeneralProps, 'size'>

export const LinkButton = memo(function LinkButton({
  children,
  className,
  hasPadding,
  size = 'nm',
  contentPosition = 'contentCenter',
  innerRef,
  onClick,
  to,
  testId,
  ...props
}: IProps) {
  const navigate = useNavigate()

  const handleClick: MouseEventHandler<'a'> = useCallback(
    (e) => {
      if (to) {
        navigate({ to })
      }

      if (onClick) {
        onClick(e)
      }
    },
    [to, onClick, navigate]
  )

  return (
    <BaseLink
      {...props}
      childrenContent={children}
      className={cn(s[size], s[contentPosition], { [s.hasPadding]: hasPadding }, className)}
      onClick={handleClick}
      testId={testId}
    >
      {({ content, ...renderProps }) => (
        <a ref={innerRef} {...renderProps} data-test-id={testId}>
          {content}
        </a>
      )}
    </BaseLink>
  )
})
